'use client'

import { TextLink } from '@/General/TextLink'
import { useCookieValue } from '@/Cookies/useCookies'

const US_ADDRESS =
  '11355 Folsom Blvd Unit K, Rancho Cordova, CA 95742, United States'
const UK_ADDRESS =
  'Unit 5, Guild House, 221 Kincraig Road, Blackpool, FY2 0PJ, United Kingdom'

export const InfoSidebar = () => {
  const brandCode = useCookieValue('vi-brand')
  const isUK = brandCode === 'VANISHING_INC_UK'

  return (
    <div className="bg-gray-50 rounded-lg p-6 space-y-6 mb-6">
      <img
        src="https://vinc.gumlet.io/pics/contact-us/support-wizards.png?w=480&dpr=2"
        alt="Support Wizards"
        className="rounded-lg"
      />

      <div>
        <strong>Want an order update?</strong>
        <p>
          Find out exactly where your order is right now!{' '}
          <TextLink
            href="/account/"
            className="text-green-600 font-bold underline hover:no-underline"
          >
            Track your order
          </TextLink>
        </p>
      </div>

      <div>
        <strong>Submitting a trick to us?</strong>
        <p>
          Please use{' '}
          <TextLink href="/submit-a-trick/">our trick submission form</TextLink>
          .
        </p>
      </div>

      <div>
        <strong>Shipping costs</strong>
        <p>
          Add a product to your cart to see the shipping costs to your country.
        </p>
      </div>

      <div>
        <strong>Want a job?</strong>
        <p>
          We list all current openings in our{' '}
          <TextLink href="/jobs/">jobs area</TextLink>.
        </p>
      </div>

      <div>
        <strong>Who you're emailing</strong>
        <p>
          We're a team of magicians who love to talk magic! We look forward to
          hearing from you.
        </p>
        <img
          src="https://vinc.gumlet.io/pics/team-costa-rica.jpg?w=480&dpr=2"
          alt="Our team"
          className="rounded-lg my-2"
        />
        <p className="text-sm text-gray-500">
          From left to right: Kyle, Andi, Josh, Mark, George, Nathan
        </p>
      </div>

      <hr />
      <p>
        <strong>Write to us at:</strong>
        <br />
        {isUK ? UK_ADDRESS : US_ADDRESS}
      </p>
    </div>
  )
}
